var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpreadsheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 27,
    height: 27,
    rx: 1.5,
    stroke: "#81250B",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 28V2h3v26h-3z",
    clipRule: "evenodd",
    fill: "#81250B",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.106h24v3H3v-3zM3 18.035h24v3H3v-3z",
    clipRule: "evenodd",
    fill: "#81250B",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMzAgMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjEuNSIgeT0iMS41IiB3aWR0aD0iMjciIGhlaWdodD0iMjciIHJ4PSIxLjUiIHN0cm9rZT0iIzgxMjUwQiIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGQ9Im04LjUgMjh2LTI2aDN2MjZoLTN6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM4MTI1MEIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8cGF0aCBkPSJtMyA5LjEwNjRoMjR2M2gtMjR2LTN6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM4MTI1MEIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8cGF0aCBkPSJtMyAxOC4wMzVoMjR2M2gtMjR2LTN6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM4MTI1MEIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";
export { SvgSpreadsheet as ReactComponent };